import { useMutation, useQueryClient } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: notificationService.markAllRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all }),
  })
}
